module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/a70ba2a0c66d0596f08be87ca41063c9.png";